import {createRouter, createWebHistory} from 'vue-router';
import {useAuthorizationStore} from "@/stores/AuthorizationStore/AuthorizationStore";
import Application from "@/views/ApplicationEditView.vue";
import Models from "@/views/ModelPricingView.vue";
import User from "@/views/UserView.vue";
import ApplicationUser from "@/views/ApplicationUserView.vue";

const routes = [
    {
        path: "/",
        redirect: "/dashboard",
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/DashboardView.vue"),
        meta: {
            requireAuth: true,
        },
    },
    {
        path: "/application",
        name: "application",
        component: Application,
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/user',
        name: 'user',
        component: User,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/application-user',
        name: 'application-user',
        component: ApplicationUser,
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/models',
        name: 'models',
        component: Models,
        meta: {
            requireAuth: true
        }
    },
    // Add Swagger UI route with dynamic type parameter
    {
        path: "/docs/user",
        name: "docs-user",
        component: () => import("@/views/UserSwaggerUIView.vue"),

        meta: {
            requireAuth: true, // Optional: restrict documentation access based on auth status
        },
    },
    {
        path: "/agent/:id?",
        name: "agent",
        component: () => import("@/views/AgentView.vue"),
        meta: {
            requireAuth: true,
            service: "agent",
        },
    },
    {
        path: "/usage-log",
        name: "usage-log",
        component: () => import("@/views/UsageLogView.vue"),
        meta: {
            requireAuth: true,
        },
    },
    {
        path: "/workflow/:id?",
        name: "workflow",
        component: () => import("@/views/WorkflowEditorView.vue"),
        meta: {
            requireAuth: true,
            service: "workflow",
        },
    },
    {
        path: "/knowledge-base",
        name: "knowledge-base",
        component: () => import("@/views/KnowledgeBaseView.vue"),
        meta: {
            requireAuth: true,
            service: "knowledge_base",
        },
    },
    {
        path: "/artifacts",
        name: "artifacts",
        component: () => import("@/views/ArtifactManagementView.vue"),
        meta: {
            requireAuth: true,
            service: "workflow",
        },
    },

    {
        path: "/email-notification",
        name: "email-notification",
        component: () => import("@/views/EmailNotificationView.vue"),
        meta: {
            requireAuth: true,
        },
    },
    {
        path: "/workflow-approvals",
        name: "workflow-approvals",
        component: () => import("@/views/WorkflowApprovalView.vue"),
        meta: {
            requireAuth: true,
            service: "workflow",
        },
    },
    {
        path: "/execution-management",
        name: "execution-management",
        component: () => import("@/views/ExecutionManagementView.vue"),
        meta: {
            requireAuth: true,
        },
    },
    {
        path: "/system-settings",
        name: "system-settings",
        component: () => import("@/views/SystemSettingsView.vue"),
        meta: {
            requireAuth: true,
        },
    },
    {
        path: "/app-services",
        name: "app-services",
        component: () => import("@/views/AppServicesView.vue"),
        meta: {
            requireAuth: true,
            service: "app_chat",
        },
    },
];

const router = createRouter({
    history: createWebHistory(/*import.meta.env.BASE_URL*/),
    routes,
});

// Redirect to home when navigating to a route whose required service is disabled
router.beforeEach((to) => {
    const requiredService = to.meta?.service as string | undefined
    if (requiredService) {
        const authStore = useAuthorizationStore()
        if (!authStore.hasService(requiredService)) {
            return { name: 'dashboard' }
        }
    }
})

export default router;
